"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requiredServices = exports.optionalServices = void 0;
const optionalServices = exports.optionalServices = ['kpiApi'];
const requiredServices = exports.requiredServices = ['globalApi', 'staticApi', 'graphQl', 'identity', 'online', 'mobileOfficeApi', 'graphQlNet'];
